<template>
  <div
    class="company-logo"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
    @click="$emit('select')"
  >
    <div
      v-if="logo"
      class="thumbnail"
    >
      <b-img
        :src="logo"
        rounded
        :width="size + 'px'"
        :height="size + 'px'"
        :alt="name"
      />
    </div>
    <b-avatar
      v-else
      v-b-tooltip.hover
      :size="size"
      variant="dark"
      :title="name"
      :text="avatarText(name)"
    />
    <feather-icon
      v-if="isHovered && removable"
      class="remove-icon"
      icon="XIcon"
      size="16"
      @click.stop="$emit('remove')"
    />
  </div>
</template>
<script>
import {
  BImg,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'

export default {
  name: 'CompanyThumb',
  components: {
    BAvatar,
    BImg,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  setup() {
    return {
      avatarText,
    }
  },
  props: {
    logo: { type: String, default: '' },
    name: { type: String, default: '' },
    size: { type: Number, default: 35 },
    removable: { type: Boolean, default: false },
  },
  data() {
    return {
      isHovered: false,
    }
  },
}
</script>
<style lang="scss" scoped>
  .company-logo {
    position: relative;
    display: inline-block;

    .thumbnail {
      border-radius: 50%;
      border: 1px solid #dae1e7;
      display: inline-block;

      img {
        object-fit: contain;
      }
    }
    .remove-icon {
      position: absolute;
      top: 0;
      right: 0;
      background-color: #ffffff;
      border: 1px solid #dae1e7;
      border-radius: 50%;
      padding: 2px;
      cursor: pointer;
      transition: transform 0.2s ease, opacity 0.2s ease;

      &:hover {
        transform: scale(1.2);
        opacity: 0.8;
      }
    }

  }
</style>
